import { CancelAppointmentQueueCommand } from "@/models/club";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { appointmentService } from "..";

// AppointmentQueue/Cancel cancels the queue's open SnappPay transaction first and only then the
// booking; if SnappPay refuses, nothing is cancelled. Appointment/Cancel would skip SnappPay.
function useCancelAppointmentQueue() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (command: CancelAppointmentQueueCommand) =>
      appointmentService.cancelAppointmentQueue(command),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["getAppointmentDeposit"] });
      queryClient.invalidateQueries({ queryKey: ["getDailyAppointment"] });
    },
  });
}

export default useCancelAppointmentQueue;
